import useToast from '@/hooks/useToast'
import { ServerActionErrorResponse, ServerActionSuccessResponse } from '@/types/action-response'
import { ErrorEntity } from '@/types/api-response'

class ApiError extends Error {
  status: number
  errors: ErrorEntity[]
  constructor(status: number, errors: ErrorEntity[]) {
    super(status.toString())
    this.status = status
    this.errors = errors
  }
}

const isApiError = (e: unknown): e is ApiError => {
  if (e === undefined || e === null) {
    return false
  }
  const valueHasResProperty =
    e instanceof Object && 'errors' in e && typeof (<{ errors: unknown }>e).errors === 'object'
  if (valueHasResProperty) {
    return true
  }
  return false
}

export const useServerActionHandler = () => {
  const toast = useToast()

  const responseHandler = <T>(res: ServerActionSuccessResponse<T> | ServerActionErrorResponse) => {
    if (res.ok) {
      return res
    } else {
      throw new ApiError(res.status, res.errors)
    }
  }

  const errorHandler = (e: Error | ApiError) => {
    if (isApiError(e)) {
      toast({
        status: 'error',
        title: e.errors.map((error) => error.message).join(','),
        description: e.status === 500 && 'お手数をおかけしますが、しばらく時間を置いてからやり直してください',
      })
    } else {
      // sentry
      // server action上のエラーはここに入らないが、念のため
      toast({
        status: 'error',
        title: 'サーバー側でエラーが発生しました',
        description: 'お手数をおかけしますが、しばらく時間を置いてからやり直してください',
      })
    }
  }

  return {
    responseHandler,
    errorHandler,
  }
}
